<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>系统通知</span>
      </div>
      <!--工具栏-->
      <div class="toolbar">
        <el-form
          :inline="true"
          :model="pageRequest.params.content"
          :size="size"
        >
          <el-form-item>
            <el-input
              v-model="pageRequest.params.content.title"
              placeholder="请输入标题关键词"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="fa fa-search" type="primary" @click="findPage">
              {{ $t("action.search") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="pageResult.content"
        :size="size"
        :show-header="true"
        v-loading="tableLoading"
        :element-loading-text="$t('action.loading')"
      >
        <!--序号，可分页-->
        <el-table-column
          label="#"
          type="index"
          show-overflow-tooltip
          width="30px"
        >
          <template slot-scope="scope">
            <span>{{
              (pageRequest.pageNum - 1) * pageRequest.pageSize +
                scope.$index +
                1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="200px">
          <template slot-scope="scope">
            <el-link
              :underline="false"
              @click="openContent(scope.row)"
              target="_blank"
              >{{ scope.row.title }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="updateDate" label="发布日期"></el-table-column>
      </el-table>
    </el-card>

    <!-- 新增修改界面 -->
    <el-dialog
      :title="dataForm.title"
      width="900px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div
        width="800px"
        v-loading="editLoading"
        :element-loading-text="$t('action.loading')"
      >
        <el-row>
          <div>
            <span style="float:right">发布日期：{{ dataForm.updateDate }}</span>
          </div>
          <el-divider></el-divider>
        </el-row>
        <el-row><div v-html="dataForm.content" /> </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      size: "",
      tableLoading: false,
      editLoading: false,
      showOperation: true,
      showBatchDelete: false,
      showMultipleSelection: false,
      columns: [],
      // 分页信息
      pageRequest: {
        pageNum: 1,
        pageSize: this.global.DEFAULT_PAGE_SIZE,
        params: {
          content: { status: this.global.KEYS.STATUS_ACTIVE, type: "NOTICE" }
        }
      },
      pageResult: {},
      dialogVisible: false,
      dataForm: {
        id: null,
        type: "NOTICE",
        content: "",
        isTop: false,
        status: this.global.KEYS.STATUS_ACTIVE
      },
      dataRule: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        content: [{ required: true, message: "内容不能为空", trigger: "blur" }]
      },
      typeData: [
        {
          value: "NOTICE",
          label: "最新通知"
        },
        {
          value: "CLASS",
          label: "大学堂"
        }
      ]
    };
  },
  watch: {
    getType() {
      this.findPage();
    }
  },
  computed: {
    getType() {
      return this.$store.state.tab.topTabsActiveName;
    }
  },
  methods: {
    findPage: function(data) {
      //设置参数内容，从路径中获取
      if (this.$route.params.type) {
        this.pageRequest.params.content.type = this.$route.params.type.toUpperCase();
      }
      this.tableLoading = true;
      //获取数据
      this.$api.content
        .findPage(this.pageRequest)
        .then(res => {
          this.tableLoading = false;
          //操作成功
          if (res.code == 200) {
            this.pageResult = res.data;
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    openContent: function(data) {
      this.dialogVisible = true;
      this.editLoading = true;
      //获取数据
      this.$api.content
        .getOne(data.id)
        .then(res => {
          this.editLoading = false;
          //操作成功
          if (res.code == 200) {
            this.dataForm = res.data;
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    }
  },
  mounted() {
    this.findPage();
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/Content/List.vue